import Layout from "../components/Layout";
import about_wide_1 from "../../assets/niceshop/img/about/about-wide-1.webp";
import person_f_7 from "../../assets/niceshop/img/person/person-f-7.webp";
import { Link } from "react-router-dom";
import { getRootUrl } from "../../consts";

function SignInContent(){
  const rootUrl = getRootUrl();
  return   <main className="main">

    {/* <!-- Page Title --> */}
    <div className="page-title light-background">
      <div className="container d-lg-flex justify-content-between align-items-center">
        <h1 className="mb-2 mb-lg-0">Sign in</h1>
        <nav className="breadcrumbs">
          <ol>
            <li><a href="index.html">Home</a></li>
            <li className="current">Register</li>
          </ol>
        </nav>
      </div>
    </div>{/* <!-- End Page Title --> */}

    {/* <!-- Register Section --> */}
    <section id="register" className="register section">

      <div className="container" data-aos="fade-up" data-aos-delay="100">

        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="registration-form-wrapper">
              <div className="form-header text-center">
                <h2>Sign in</h2>
                {/* <p>Create your account and start shopping with us</p> */}
              </div>

              <div className="row">
                <div className="col-lg-8 mx-auto">
                  <form action="register.php" method="post">

                    {/* <div className="form-floating mb-3">
                      <input type="text" className="form-control" id="fullName" name="fullName" placeholder="Full Name" required="" autocomplete="name" />
                      <label htmlFor="fullName">Full Name</label>
                    </div> */}

                    <div className="form-floating mb-3">
                      <input type="email" className="form-control" id="email" name="email" placeholder="Email Address" required="" autocomplete="email" />
                      <label htmlFor="email">Email Address</label>
                    </div>

                    <div className="form-floating mb-3">
                      <input type="password" className="form-control"
                        id="password" name="password" placeholder="Password" required="" />
                      <label htmlFor="email">Password</label>
                    </div>

                    {/* <div className="form-floating mb-4">
                      <select className="form-select" id="country" name="country" required="">
                        <option value="" selected="" disabled="">Select your country</option>
                        <option value="us">United States</option>
                        <option value="ca">Canada</option>
                        <option value="uk">United Kingdom</option>
                        <option value="au">Australia</option>
                        <option value="de">Germany</option>
                        <option value="fr">France</option>
                        <option value="jp">Japan</option>
                        <option value="other">Other</option>
                      </select>
                      <label htmlFor="country">Country</label>
                    </div> */}

                    {/* <div className="form-check mb-4">
                      <input className="form-check-input" type="checkbox" id="termsCheck" name="termsCheck" required="" />
                      <label className="form-check-label" htmlFor="termsCheck">
                        I agree to the <a href="#">Terms of Service</a> and <a href="#">Privacy Policy</a>
                      </label>
                    </div> */}

                    {/* <div className="form-check mb-4">
                      <input className="form-check-input" type="checkbox" id="marketingCheck" name="marketingCheck" />
                      <label className="form-check-label" htmlFor="marketingCheck">
                        I would like to receive marketing communications about products, services, and promotions
                      </label>
                    </div> */}

                    <div className="d-grid mb-4">
                      <button type="submit" className="btn btn-register">Sign in</button>
                    </div>

                    <div className="login-link text-center">
                      <p>No account yet?? <Link
                        to={`${rootUrl}/wwapp/register`}
                      >Register</Link></p>
                    </div>
                  </form>
                </div>
              </div>

              {/* <div className="social-login">
                <div className="row">
                  <div className="col-lg-8 mx-auto">
                    <div className="divider">
                      <span>or sign up with</span>
                    </div>
                    <div className="social-buttons">
                      <a href="#" className="btn btn-social">
                        <i className="bi bi-google"></i>
                        <span>Google</span>
                      </a>
                      <a href="#" className="btn btn-social">
                        <i className="bi bi-facebook"></i>
                        <span>Facebook</span>
                      </a>
                      <a href="#" className="btn btn-social">
                        <i className="bi bi-apple"></i>
                        <span>Apple</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div> */}

              <div className="decorative-elements">
                <div className="circle circle-1"></div>
                <div className="circle circle-2"></div>
                <div className="circle circle-3"></div>
                <div className="square square-1"></div>
                <div className="square square-2"></div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </section>{/* <!-- /Register Section --> */}

  </main>;
}

export default function SignIn(){
    return <Layout>
      <SignInContent></SignInContent>
    </Layout>

}